<mat-card id="diagnosis-code-card" class="has-progress-bar card-table">
  <mat-progress-bar
    [mode]="(data.appointment$ | async) == null ? 'indeterminate' : 'determinate'"
  ></mat-progress-bar>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{ 'patient-details.diagnosis-code-card.title' | translate }}</span>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="1rem">
      <ng-container *mmxHasIntegrationSupport="'UPDATE_APT_DIAGNOSIS'">
        <button
          *appHasPermission="'appointment.edit'"
          mat-stroked-button
          [satPopoverAnchor]="addCode"
          (click)="openForm(addCode)"
        >
          <mat-icon>add</mat-icon>
          <span>{{ 'common.add' | translate }}</span>
        </button>
      </ng-container>

      <sat-popover #addCode>
        <mat-card class="p-4">
          <form [formGroup]="formGroup">
            <mat-form-field appearance="fill">
              <mat-label>{{
                'patient-details.diagnosis-code-card.enter-new-code' | translate
              }}</mat-label>
              <mmx-diagnosis-code-chips-selector
                [noCopyPaste]="true"
                formControlName="codes"
              ></mmx-diagnosis-code-chips-selector>
              <mat-error color="warning" *ngIf="formError">{{formError | translate}}</mat-error>
            </mat-form-field>
            <div fxLayoutAlign="space-between center">
              <button mat-button (click)="addCode.close()">
                  {{'common.cancel' | translate}}
              </button>
              <button
                color="primary"
                mat-button
                [disabled]="isSaving"
                (click)="addCodes(addCode)"
              >
              <ng-container></ng-container>
              <ng-container>
                {{ 'common.save' | translate }}
              </ng-container>
              </button>
            </div>
          </form>
        </mat-card>
      </sat-popover>
    </div>
  </mat-card-title>
  <ng-container *ngIf="data.appointment$ | async as appointment">
    <mat-card-content
      *ngIf="appointment?.diagnosisCodes?.length"
      fxLayout="column"
    >
      <table mat-table [dataSource]="appointment?.diagnosisCodes">
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>
            {{
              'patient-details.diagnosis-code-card.diagnosis-code'
                | translate
            }}
          </th>
          <td mat-cell *matCellDef="let diagnosisCode">
            {{ diagnosisCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>
            {{
              'patient-details.diagnosis-code-card.diagnosis-code-system'
                | translate
            }}
          </th>
          <td mat-cell *matCellDef="let diagnosisCode">
            {{ getCodeType(diagnosisCode) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>
            {{
              'patient-details.diagnosis-code-card.diagnosis-code-description'
                | translate
            }}
          </th>
          <td mat-cell *matCellDef="let diagnosisCode">
            <!-- {{ getDescription(diagnosisCode) }} -->
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let diagnosisCode">
            <ng-container *mmxHasIntegrationSupport="'UPDATE_APT_DIAGNOSIS'">
              <mat-icon color="warn" (click)="deleteDiagnosisCode(diagnosisCode)">close</mat-icon>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>

    <mat-card-content
      *ngIf="!appointment?.diagnosisCodes?.length"
      fxLayout="column"
    >
      <div class="mmx-card-padding">
        {{
          'patient-details.diagnosis-code-card.no-diagnosis-code' | translate
        }}
      </div>
    </mat-card-content>
  </ng-container>

  <mat-card-content
    *ngIf="(data.appointment$ | async) === null"
    fxLayout="column"
  >
    <div class="mmx-card-padding">{{ 'common.loading' | translate }}...</div>
  </mat-card-content>
</mat-card>
